import { ActionTree } from "vuex";
import axios from "axios";
import { RootState } from "@/store/types";
import {
  StatisticState,
  GroupFilterParams,
  DetailFilterParams,
} from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  getSmsStatisticGroup: ({ commit, dispatch }, data: GroupFilterParams) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/group/sms",
        params: data,
      })
        .then((resp) => {
          commit("setSmsStaticGroup", resp.data.messages);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportSmsStatisticGroup: ({ commit, dispatch }, data: GroupFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/group/sms/export",
        params: data,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getSmsStatisticDetail: ({ commit, dispatch }, data: DetailFilterParams) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/detail/sms",
        params: data,
      })
        .then((resp) => {
          let messages = resp.data?.messages ?? [];
          if (data.page_number > 1) {
            commit("pushSmsStaticDetail", messages);
          } else {
            commit("setSmsStaticDetail", messages);
          }
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportSmsStatisticDetail: ({ commit, dispatch }, data: GroupFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/detail/sms/export",
        params: data,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSmsStatisticDetailInfo: ({ commit, dispatch }, id: string) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/detail/sms/" + id.replace(/#/g, "%23"),
      })
        .then((resp) => {
          let messageItem = resp.data;
          resolve(messageItem);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  resendSmsMessage: ({ commit, dispatch }, id: string) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/acapi/tools/sms/resend',
        data: {message_ids: [id]}
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
};
